module.exports = __webpack_public_path__ + "static/media/cake-topper@1x.c060abcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cake-topper@1x.jpg
// module id = 474
// module chunks = 0